import { getMarqueeCardImageUrl } from '#src/app/pages/homepage/shared/utils';

import type { I18n, MarqueeItem, PetitionMarqueeCardData } from './types';

/**
 * An entry with no usable image is left out rather than shown with a placeholder.
 * useMarqueeRows cycles the remaining petitions to fill the row.
 */
export function buildCard(
	item: MarqueeItem,
	index: number,
	{ translatePlural }: I18n,
): PetitionMarqueeCardData | undefined {
	// getHomepagePageData filters on the same check, so shouldShowPetitionMarquee's
	// "true guarantees visible cards" contract holds
	const imageUrl = getMarqueeCardImageUrl(item);
	if (!imageUrl) return undefined;

	const { petition } = item;
	const { displayed, displayedLocalized } = petition.signatureState.signatureCount;

	return {
		// the curated position, not the petition - a curation can hold the same petition twice,
		// and those two cards must stay separately reachable
		key: `${index}:${petition.id}`,
		petitionId: petition.id,
		title: item.summarizedTitle,
		href: `/p/${encodeURIComponent(petition.slug)}?source_location=homepage_petition_marquee`,
		isVictory: petition.status === 'VICTORY',
		imageUrl,
		signaturesLabel: translatePlural('corgi.components.petition_card.signatures', displayed, {
			countLocalized: displayedLocalized,
		}),
	};
}
